import * as React from 'react';
import $ = require('jquery');
import AppRegistry from "diy/AppRegistry";
import {
    OverlayStatusMap, moduleOverlayShow, moduleOverlayHide, moduleLoadingStarted, moduleLoadingFinished
} from 'diy/overlay/index';
import { open as moduleActionBarOpen, close as moduleActionBarClose } from 'diy/module-action-bar/index';
import ModuleActionBarContent, {
    ModuleActionBarContentProps
} from 'diy/module-action-bar/components/ModuleActionBarContent';
import l10n = require('diy/util/l10n');
import * as help from '../help/help';
let siteadminApi = require<any>('diy/site-admin/main/api');
import ModulMatrix from './ModulMatrix';
import ModulSection from './ModulSection';
import Matrix from 'diy/module/common/js/Matrix';
import {updateAll as updateModuleFitsOverlays} from "./common/js/ModuleFitsInContent";

import TabOptions from "diy/actionBar/interfaces/TabOptions";
import ModuleOverlay from './common/js/ModuleOverlay';

import {ResourceType} from "diy/resources/Resource";
import DragSource = require("../common/js/dd/DragSource");
import ExistingModuleDragSource = require("./common/js/dd/ExistingModuleDragSource");

import {AppState} from 'diy/redux/app/state';

type FileManagerSourcesConfig = __diy.FileManager.SourcesConfig;

//FIXME: No definition for our version of Hammer.JS
declare var Hammer: any;

/** @deprecated Use Modul.getInstance() instead */
declare var mm: {
    [moduleId: string]: Modul;
};

type Resources = {
    css?: string[];
};

export interface UpdateResponse {
    cmsView: string;
    editView: string;
    resources?: Resources;
}

export interface SaveResponse extends UpdateResponse {

}

interface CancelResponse extends SaveResponse {

}

export interface OpenConfig {
    tracking?: boolean;
}

export interface ModuleSupportsList {
    moduleMove: boolean;
    moduleDuplicate: boolean;
    moduleDelete: boolean;
}
export interface ModuleData {
    supports: ModuleSupportsList;
    fitsInContent: boolean;
    alias?: string;
    isInSectionLoop: boolean;
}

interface AddModuleParams {
    moduleName: string;
}

export interface InsertDestinationParams {
    pageId?: number;
    matrixId?: number;
    afterChildId?: number;
}

export interface LimitationResponse {
    renderWeight: number;
    hasReachedCriticalLimit: boolean;
    hasReachedMaximumLimit: boolean;
}

interface InsertSuccessResponse extends LimitationResponse {
    pageUrl: string;
    cmsView: string;
    editView: string;
    moduleId: number;
    childId: number;
    matrixID: number;
    resources?: Resources;
}

interface InsertModuleObject {
    getInsertPlaceholder(): JQuery;
    getInsertParams(): AddModuleParams;
}

interface ModuleInsertConfig {
    moduleType: string;
    moduleName: string;
    webcomponentId?: string;
    sectionName?: string;
}

interface ModuleInsertParams {
    moduleName: string;
    additionalParam: string;
}

/**
 * module object that is in open state
 */
let activeModule: Modul = null;

/**
 * Element used for the error dialog for the insert method
 * Need this to avoid multiple error dialogs stacking
 */
let msgEl = $('<div></div>');

function getStore() {
    return AppRegistry.getStoreProvider().getStore();
}

export const ModuleType = {
    GALLERY: 'gallery',
    IMAGE_SUBTITLE: 'imageSubtitle',
    MATRIX: 'matrix',
    SECTION: 'section',
    SECTION_CONTAINER: 'sectionContainer',
    TEXT_WITH_IMAGE: 'textWithImage',
    WEBCOMPONENT: 'webcomponent'
};

export default class Modul {
    static hoverModule: Modul;

    CONFIG_MIN_WIDTH = 550;
    modul: JQuery = null;
    form: JQuery;
    $iframe: JQuery;
    moduleId: number = null;
    matrixId: number;
    moduleType: string = null;
    /* tslint:disable:variable-name */
    module_name: string;
    /* tslint:enable:variable-name */
    saveAction: () => void = null;
    hasConfigView = true;
    hasActionBar = false;
    helpArticleId: string;
    textLabel = '';
    overlay: ModuleOverlay = null;
    overlayMarginTopScrollback = 0;
    imageAmount: number;
    moduleElement: HTMLElement;

    hasSpotlightBorder = true;
    saveTimeout = 60000;

    /**
     * whether to stop hide/show overlay methods from being run
     */
    overlayFrozen = false;
    isNew: boolean;
    obsHover: () => void;
    obsHoverOut: () => void;

    protected data: ModuleData;

    constructor(moduleId: number) {
        this.modul = $('#modul_' + moduleId);
        this.moduleElement = document.getElementById("modul_" + moduleId);
        this.moduleId = moduleId;
        // accessing matrixId directly is still used, so I will
        // initialize it here
        this.matrixId = this.getMatrixId();
        this.saveAction = this.save;

        this.init();

        $('.mod-bar-primary').click(function(ev) {
            let t = $(ev.target);

            if (t.is('a') && t.hasClass('mod-bar-primary-section-tab') && !t.hasClass('edit-image-aviary')) {
                $(this).find('a').each(function(i) {
                    $(this).removeClass('mod-bar-primary-selected');
                });
                t.addClass('mod-bar-primary-selected');
            }
        });

        //in this order
        this.initOverlay();

        if (!this.hasActionBar) {
            this.initButtons();
        }

        $(document).trigger('diy.editor.moduleInitialized', [this]);
    }
    init() {
        // override this
    }
    getData() {
        return this.data;
    }
    getAlias() {
        return this.data.alias;
    }
    isInSectionLoop() {
        return this.data.isInSectionLoop;
    }
    // Called from PHP
    loadData(data: ModuleData) {
        this.data = data;
    }
    initButtons() {
        this.getCancelBtn().button().click(() => {
            this.close(true, true, false, true);
        });
        this.getSaveBtn().button().click($.proxy(this.onSaveBtnClick, this));
        this.getToolbox().hide();
    }
    onSaveBtnClick() {
        getStore().dispatch(moduleOverlayHide({moduleId: this.moduleId}));
        let isNew = this.getIsNew();
        this.runSaveAction.apply(this, arguments);
        if (isNew && this.getModuleType() !== ModuleType.SECTION) {
            $(document.body).trigger('NewModuleSaved.BSA');
        }
    }
    deleteAction() {
        this.getMatrix().del(this.getChildId(), this.moduleId);
    }
    getModuleType() {
        return this.modul.attr('data-moduletype');
    }
    needsCover() {
        return this.module_name === 'facebook' ||
            this.module_name === 'twitter' ||
            this.module_name === 'product_search';
    }
    startHoverObserver() {
        if (diy.editor.uiPreference.isPointerModeTouch()) {
            (new Hammer($('.diyw').get(0), {
                stop_browser_behavior: {}
            })).on('touchstart', function() {
                if (Modul.getActiveModule()) {
                    return;
                }
                if (Modul.hoverModule) {
                    Modul.hoverModule.obsHoverOut();
                }
                Modul.hoverModule = null;
            });
            (new Hammer(this.modul[0], {
                stop_browser_behavior: {}
            })).on('tap', () => {
                if (this.moduleType === 'matrix' && Modul.hoverModule &&
                    Modul.hoverModule.moduleType !== 'matrix' &&
                    this.modul.find('.matrix-module-configuration').is(":visible")) {
                    return;
                }
                if (Modul.hoverModule === this) {
                    return;
                }
                if (Modul.hoverModule) {
                    Modul.hoverModule.obsHoverOut();
                }
                Modul.hoverModule = this;
                this.obsHover();
            });
        } else {
            this.modul.bind('mouseenter', this.obsHover);
        }
    }
    startHoverOutObserver() {
        if (!diy.editor.uiPreference.isPointerModeTouch()) {
            this.getOverlayWrapper().bind('mouseleave', this.obsHoverOut);
            this.modul.bind('mouseleave', this.obsHoverOut);
        }
    }
    getIsNew() {
        return this.isNew;
    }
    setIsNew(v: boolean) {
        this.isNew = v;
        return this.isNew;
    }
    getChildId() {
        return parseInt(this.modul.attr('data-matrixChildId'), 10);
    }
    getAfterChildId() {
        let prevModuleEl = this.getPrevModul(0);
        let afterChildId = 0;

        if (prevModuleEl.length) {
            afterChildId = parseInt(prevModuleEl.attr('data-matrixchildid'), 10);
        }

        return afterChildId;
    }
    getMatrixId() {
        return parseInt(this.modul.attr('data-matrixId'), 10);
    }
    getMatrix() {
        return Matrix.getInstance(this.getMatrixId());
    }
    getMatrixModuleParent(): ModulMatrix {
        const matrix = this.getParentModules()
            .filter(m => m.getModuleType() === ModuleType.MATRIX)
            .shift() as ModulMatrix;
        return matrix || null;
    }
    getParentSection(): ModulSection {
        const section = this.getParentModules()
            .filter(m => m.getModuleType() === ModuleType.SECTION)
            .shift() as ModulSection;
        return section || null;
    }
    getParentModules() {
        return (this.modul.parents('[data-moduleid]').toArray() as HTMLElement[])
            .map(element => {
                let moduleId = element.getAttribute('data-moduleid');
                return Modul.getInstance(moduleId);
            });
    }
    getChildModules() {
        return (this.modul.find("[data-moduleid]").toArray() as HTMLElement[])
            .map(elem => Modul.getInstance(elem.getAttribute('data-moduleid')))
            .filter(m => m !== undefined);
    }
    getPageId() {
        return this.getMatrix().pageId;
    }
    getPrevModul(index?: number) {
        index = index || 0;
        return this.modul.prevAll('.modulelt').eq(index);
    }
    getNextModul(index?: number) {
        index = index || 0;
        return this.modul.nextAll('.modulelt').eq(index);
    }
    /**
     * @return {jQuery} wrapper for module overlay/toolbox and editor elements
     */
    getOverlayGroup() {
        return $("#module-overlay-group-" + this.moduleId);
    }
    remove() {
        let children = this.getChildModules();
        children.forEach(childModule => {
            childModule.remove();
        });

        // remove with .diye parent
        this.getOverlayGroup().parent().remove();
        this.getModuleElement().remove();

        if (activeModule === this) {
            activeModule = null;
        }
    }
    /**
     * @return {jQuery} with the toolbox (all buttons container)
     */
    getToolbox() {
        return this.overlay.getToolbox();
    }
    getMoveBtn() {
        return this.getToolbox().find('.toolmove');
    }
    getSaveBtn() {
        return this.getEditorContainer().find('#modul_' + this.moduleId + '_save_button');
    }
    getCancelBtn() {
        return this.getEditorContainer().find('#modul_' + this.moduleId + '_cancel_button');
    }
    getDeleteBtn() {
        return this.getToolbox().find('.tooldelete');
    }
    getContentContainer() {
        return this.getModuleElement();
    }
    getModuleElement() {
        return this.modul;
    }
    getEditorContainer() {
        return $("#modul_" + this.moduleId + "_formdiv");
    }
    getEditorPositionedContainer() {
        return  this.getEditorContainer().find('.module-config-outer-container');
    }
    /**
     * @return {jQuery} overlay and toolbox wrapper
     */
    getOverlayWrapper() {
        return this.overlay.getOverlayElement();
    }
    getIsInEditMode() {
        return this.modul.hasClass('open');
    }
    showLoading($elem?: JQuery) {
        getStore().dispatch(moduleLoadingStarted({moduleId: this.moduleId}));
    }
    hideLoading($elem?: JQuery) {
        getStore().dispatch(moduleLoadingFinished({moduleId: this.moduleId}));
    }
    hideConfigLoading() {
        this.getEditorPositionedContainer().loadingBox().remove();
    }
    showConfigLoading() {
        this.getEditorPositionedContainer().loadingBox({useOverlay: true}).show();
    }
    getSaveData(): any {
        let data = $('#formular_' + this.moduleId).serializeArray();
        data.push({
            name: '_diyNewlyAdded',
            value: this.getIsNew() ? '1' : '0'
        });
        return data;
    }
    save() {
        let self = this;
        if (self.form) {
            self.form.diy_form('clearErrors');
        }
        if (!this.hasActionBar) {
            this.getSaveBtn().button("disable");
        }
        $.ajax({
            url : systemurl + 'app/module/module/update',
            data : self.getSaveData(),
            dataType : 'json',
            type : 'POST',
            timeout: this.saveTimeout,
            success : function(r) {
                if (self.$iframe) {
                    self.$iframe.remove();
                    delete self.$iframe;
                }
                if (r.error) {
                    if (r.refresh) {
                        mm[r.moduleId].doAfterSave(r);
                    } else {
                        mm[r.moduleId].getModuleElement().removeClass('hover_loading');
                    }

                    if (r.message) {
                        // actually show the error over the opened module
                        self.open();
                        if (self.form) {
                            self.form.diy_form('addError', r.message);
                        } else {
                            self.getEditorContainer().message({
                                message: r.message,
                                status: 'error'
                            });
                        }
                    }
                } else {
                    mm[r.moduleId].doAfterSave(r);
                }
                // fixes bug DHDIY-19637 - do not clear cookies if previous module
                // was saved by going to another module
                if (!activeModule) {
                    self.clearEditCookies();
                }
                self.hideLoading();
                $(document).trigger('diy-editor-module-saved', r.moduleId);
            },
            complete: function() {
                if (!self.hasActionBar) {
                    self.getSaveBtn().button("enable");
                }
            }
        });
        self.wait(true);
        self.getModuleElement().addClass('hover_loading');
    }
    doAfterSave(r: SaveResponse) {
        this.removeHoverLoading();
        this.updateModul(r.cmsView, r.editView, r.resources);
    }
    cancelEdit() {
        let self = this;
        $.ajax({
            url: systemurl + 'app/module/module/canceledit',
            data: {moduleId: self.moduleId},
            dataType: 'json',
            type: 'POST',
            success: function(r) {
              if ( self.$iframe ) {
                self.$iframe.remove();
                delete self.$iframe;
              }
              if (r.error) {
                // TODO what if there was an error on cancelling???
              }
              mm[r.moduleId].doAfterCancelEdit(r);
              mm[r.moduleId].hideLoading();
            }
        });
        self.wait(true);
        self.getModuleElement().addClass('hover_loading');
    }
    doAfterCancelEdit(r: CancelResponse) {
        //moved here due to IE8 asynchronous problems
        $.cookie('cancelEdit', null, {path: '/'});
        this.updateModul(r.cmsView, r.editView, r.resources);
    }
    updateModulContent(html: string) {
        let htmlFixed = html.indexOf('<embed') === -1 &&
            html.indexOf('wmode') === -1 ? html.replace('<embed', '<embed wmode="transparent"') : html;
        this.getContentContainer().html(htmlFixed);
    }
    updateModul(cmsView: string, editView: string, resources?: Resources) {
        let moduleId = this.moduleId;
        let modulEl = this.modul;
        let insertAfterEl = modulEl.prev();
        let parent = modulEl.parent();
        let isNew = this.getIsNew();

        // Take a snapshot of getIsInEditMode() because calling remove() will change its state
        let wasInEditMode = this.getIsInEditMode();
        this.remove();
        mm[moduleId] = null;

        // jQuery doesn't like HTML strings that don't start with <
        // trim any leading whitespaces
        cmsView = $.trim(cmsView);
        editView = $.trim(editView);

        let addElementInPage = () => {
            if (insertAfterEl.length > 0) {
                $(cmsView).insertAfter(insertAfterEl);
            } else {
                $(cmsView).prependTo(parent);
            }
            $(editView).appendTo('body');
            mm[moduleId].setIsNew(isNew);
            if (wasInEditMode) {
                mm[moduleId].modul.addClass('open');
            }

            $(document).trigger('diy-editor-module-rerendered', [this]);
        };

        if (resources) {
            Modul.handleResources(resources, addElementInPage);
        } else {
            addElementInPage();
        }
    }

    removeHoverLoading() {
         this.getModuleElement().removeClass('hover_loading');
    }
    wait(isSaving: boolean) {
        let isUserAction = true;
        this.close(false, false, isSaving, isUserAction);
        this.showLoading();
        return true;
    }
    scrollToActiveView() {
        let $element: JQuery;
        let positionedContainer = this.getEditorPositionedContainer();
        $element = (activeModule === this && positionedContainer.is(':visible')) ?
            positionedContainer :
            this.getContentContainer();
        $element.scrollIntoView();
    }
    replaceInternalLinksForEditor(content: string) {
        // hier werden die internen links für den editor aufbereitet
        // $1 = website_id, $2 = page_id, $3 = alles weitere wie
        // parameter oder ankerlinks
        // /app/5861/50562375/
        return content.replace(
            /href="\/app\/([0-9]+)\/([0-9]+)\/(.*?)"/g,
            'href="' + cc_.internalLinkPrefix + '$2/$3"'
        );
    }
    update(content: string) {
        this.getContentContainer().html(content);
    }
    sizeHoverContentOverlay() {
        let content = this.getContentContainer();
        let contentHeight = content.outerHeight(true);

        let widthWarning = this.modul.find('.width-warning-text-wrapper');
        if (widthWarning.length > 0 && contentHeight < widthWarning.outerHeight(true)) {
            contentHeight = widthWarning.outerHeight(true);
            content.height(contentHeight);
        }
    }
    adjustConfigView(hasConfigView: boolean) {
        let bottomPieceWidth: number
        ;
        if (hasConfigView === true) {
            let configContainer = this.getEditorContainer();

            //re-dimension it according needed width
            if (this.CONFIG_MIN_WIDTH && configContainer.width() < this.CONFIG_MIN_WIDTH) {
                configContainer.width(this.CONFIG_MIN_WIDTH);
            }

            bottomPieceWidth = this.overlay.getPiece('bottom').width();

            if (configContainer.width() > bottomPieceWidth && bottomPieceWidth > this.CONFIG_MIN_WIDTH) {
                configContainer.width(bottomPieceWidth);
            }

            this.overlay.glueElementToBottom(configContainer);
        }
        this.repositionOverlay();
    }
    setOpenStyle(hasConfigView: boolean) {

        // do it after adjusting the config view
        // when for right sidebar the overlay bottom piece
        // is extended to make room for the toolbox buttons
        this.adjustConfigView(hasConfigView);

        // adjust module style //
        this.modul.addClass('open');

        // add an event to adjust margin for the config window on resize
        // depends on the query resize plugin
        this.modul
            .bind('resize.moduleContent', () => {
                this.overlay.resize();
                this.adjustConfigView(hasConfigView);
            });

        if (hasConfigView === true) {
            //readjust editor
            this.getEditorContainer()
                .bind('resize.moduleEditor', () => {
                    this.adjustConfigView(hasConfigView);
                });

            $('.diywebMainGutter').bind('resize.diywebMainGutter', () => {
                this.adjustConfigView(hasConfigView);
            });
        }

        this.getOverlayGroup().addClass('open');
    }
    clearOpenStyle() {
        this.modul
            .removeClass('open')
            .unbind('resize.moduleContent');
        this.getEditorContainer()
            .unbind('resize.moduleEditor');
        $('.diywebMainGutter').unbind('resize.diywebMainGutter');

        this.getOverlayGroup().removeClass('open');

        if (!this.hasActionBar) {
            $(document).scrollTop($(document).scrollTop() - this.overlayMarginTopScrollback);
        }
        this.overlayMarginTopScrollback = 0;
        this.overlay.removeElementFromBottom(this.getEditorContainer());
    }
    open(openConfig?: OpenConfig) {
        if (activeModule) {
            let hasParentModuleInEditing = this.getParentModules()
                .filter(m => m.moduleId === activeModule.moduleId).length;

            if (!hasParentModuleInEditing) {
                Modul.abortEditingModules();
            }
        }

        getStore().dispatch(moduleOverlayShow({moduleId: this.moduleId, status: OverlayStatusMap.ACTIVE}));

        openConfig = $.extend({
            'tracking': true
        }, openConfig);

        if (openConfig.tracking) {
            this.onOpenTracking();
            /* tslint:disable:triple-equals */
            if (this.getIsNew() != true) {
                $(document.body).trigger('ModuleEditorOpened.BSA');
            }
            /* tslint:enable:triple-equals */
        }

        /* track that a module was opened for editing
         * used for sitecatalyst to track module opening */
        $(document).trigger('diy-editor-module-opened-for-editing', {
            'module': this,
            'openConfig': openConfig
        });

        activeModule = this;

        if (this.hasActionBar) {
            // TODO check if 'open' class is neede anymore
            this.modul.addClass('open');
            getStore().dispatch(moduleActionBarOpen({moduleId: this.moduleId}));
        } else {

            // make sure this module has a config view
            if (!this.hasConfigView) {
                return;
            }
            if (this.getIsInEditMode()) {
                return;
            }

            this.showEditView();

            // initialize help link
            cms.help.GuidedAssistant._instance
                ._initSiteAdminButtonByClass(cms.help.GuidedAssistant.options.modulesLinkClass);

            $.cookie('beginEdit', 1, {path: '/'});
            $.cookie('editMode', 1,  {path: '/'});

            // scroll to the edit view
            this.scrollToActiveView();
        }
    }
    protected onOpenTracking() {
        //override me
    }
    clearEditCookies() {
        $.cookie('beginEdit', null, {path: '/'});
        $.cookie('editMode', null, {path: '/'});
    }
    close(userClose?: boolean, cancelEdit?: boolean, isSaving?: boolean, isUserAction?: boolean) {
        getStore().dispatch(moduleOverlayHide({moduleId: this.moduleId}));

        if (!this.getIsInEditMode()) {
            return;
        }

        /* tslint:disable:triple-equals */
        if (isSaving != true) {
            this.clearEditCookies();
        }
        /* tslint:enable:triple-equals */

        this.clearOpenStyle();
        this.hideEditView();

        if (isUserAction && activeModule === this) {
            // scroll to module if the close action originated from
            // a user action (cancel or save)
            if (!this.hasActionBar) {
                this.getContentContainer().scrollIntoView();
            }
        }

        // if this is a brand new module (editor open first time)
        // and this is an user action (userClose)
        // then we should delete module (without confirmation)
        if (this.getIsNew() && userClose === true) {
            this.clearEditCookies();
            Matrix.getInstance(this.matrixId).del(this.getChildId(), this.moduleId);
        } else {
            // cancelEdit is an optional parameter, so it could be undefined
            // you should explicitly send false in order to not perform
            // a cancelEdit action
            if ((typeof cancelEdit === 'undefined') || (cancelEdit !== false)) {
                // sending a cancel request
                // modules have to implement server side cancel action
                // for this to have effect
                // here we only update the modul html
                $.cookie('cancelEdit', 1, {path: '/'});
                mm[this.moduleId].cancelEdit();
            }
            if (userClose || cancelEdit ) {
                this.clearEditCookies();
            }
            this.setIsNew(false);
        }
        if (activeModule === this) {
            activeModule = null;
        } else if (activeModule instanceof Modul) {
            setTimeout(() => {
                // there is another module opened, the page will change after this close, so reposition is required
                activeModule.repositionOverlay();
                if (!this.hasActionBar) {
                    activeModule.scrollToActiveView();
                }
            }, 500);
        }
    }
    showUploadStatus() {
        this.getContentContainer().html(
            '<div class="wait"><img src="' + cc_.cdnServer +
            '/s/img/cms/loading/timeline.gif" width="220" height="19" alt="" /><p>' +
            translation[4] + '</p></div>'
        );
    }
    setSaveAction(action: () => void) {
        this.saveAction = action;
    }
    runSaveAction() {
        if (this.getIsNew()) {
            /**
             * Make some SiteCatalyst tracking
             */
            $(document).trigger('diy-editor-makeWebsiteFit', {
                'condition': 'Applied',
                'name': 'Insert Elements'
            });
        }
        if (this.saveAction) {
            this.saveAction();
        } else {
            this.save();
        }
    }
    /**
     * this is used by the old jimdo Form module
     * which is not available in the MS but might be present
     * in older clients website - this should be removed once
     * the old jimdo modules are cleaned up
     * @deprecated
     */
    noSendCmsMode() {
        $('#noSendCmsMode' + this.moduleId).show();
    }

    /**
     * Usually, we wouldn't be needing moduleId parameter in this function
     * and we could just use this instead of mm[moduleId]
     * However, some modules are re-created and the "this" after re-creation
     * is not the same as the old one (sometimes becomes null)
     * TODO - So, until a general flow refactoring, we will keep using mm[moduleId]
     * and the moduleId parameter
     * @param moduleId
     */
    viewUpdateCallback(moduleId: number) {
        mm[moduleId].showLoading();
        $.post('/app/module/module/updateview', {
            moduleId : moduleId
        }, function(r) {
            mm[moduleId].updateModulContent(r.webView);
            mm[moduleId].hideLoading();
            if (mm[moduleId].afterViewUpdate) {
                mm[moduleId].afterViewUpdate(r);
            }
        }, 'json');
    }
    afterViewUpdate(r: UpdateResponse) {
        // override this
    }
    postAction(data: {}) {
        //override this
    }
    onDelete() {
        //override this
    }
    getInsertParams() {
        return {
            childId: this.getChildId()
        };
    }
    getInsertPlaceholder() {
        let placeholder = $('<div></div>');
        placeholder.attr('class', this.getModuleElement().attr('class'));
        this.getContentContainer().clone().appendTo(placeholder);
        return placeholder;
    }
    move(destinationParams: InsertDestinationParams) {
        return Modul.insert('move', this, destinationParams);
    }
    duplicate(destinationParams: InsertDestinationParams) {
        return Modul.insert('duplicate', this, destinationParams);
    }
    hide() {
        this.getOverlayGroup().hide();
        this.hideOverlay();
        this.getModuleElement().hide();
        this.getModuleElement().trigger('moduleHide');
    }
    show() {
        this.getModuleElement().show();
        this.getOverlayGroup().show();
        if (this.getIsInEditMode()) {
            this.showEditView();
        }
        //don't show the overlay; it will be triggered by mouse over
    }
    supportsDuplication() {
        return this.getData().supports.moduleDuplicate;
    }
    supportsMove() {
        return this.getData().supports.moduleMove;
    }
    /**
     * Makes this module not draggable.
     * This is useful when opening modules with inline editing, to allow
     * mouse actions on the module content without triggering drag-drop responses.
     */
    disableDragging() {
        let matrixModuleParent = this.getMatrixModuleParent();

        AppRegistry.getModuleDragDrop().removeDragSources((dragSource: DragSource) => {
            if (
                dragSource.hasOwnProperty('moduleId') && (
                    (dragSource as ExistingModuleDragSource).moduleId === this.moduleId ||
                    (
                        matrixModuleParent &&
                        (dragSource as ExistingModuleDragSource).moduleId === matrixModuleParent.moduleId
                    )
                )
            ) {
                return true;
            }
            return false;
        });
    }

    showModuleTooltip(message?: string) {
        message = message || l10n.getString('module.saveFirstWarning');

        this.getModuleElement().diy_tooltip({
            content: message,
            cls: 'diye-module-tooltip diy-alert-tooltip',
            triggerMode: 'none',
            anchor: 'top',
            anchorOffset: -10,
            alignment: 'left',
            alignmentOffset: 135 / 2
        });

        this.getModuleElement().diy_tooltip('show');
        this.getModuleElement().diy_tooltip('widget').scrollIntoView();
        this.getModuleElement().diy_tooltip('delayHide', 5000);

        let hideTooltip = () => {
            this.getModuleElement().diy_tooltip('hide');
            this.getModuleElement().add(this.getOverlayGroup())
                .unbind('.moduleTooltip');
        };

        this.getModuleElement().add(this.getOverlayGroup()).bind(
            'hideOverlay.moduleTooltip mousedown.moduleTooltip modulEditClosed.moduleTooltip',
            hideTooltip
        );
    }
    onToolUp() {
        let antePrevModuleEl = this.getPrevModul(1);
        let antePrevChildId = 0;

        if (antePrevModuleEl.length) {
            antePrevChildId = parseInt(antePrevModuleEl.attr('data-matrixchildid'), 10);
        }
        this.move({
            matrixId: this.getMatrixId(),
            pageId: 0,
            afterChildId: antePrevChildId
        });
    }
    onToolDown() {
        let nextModuleEl = this.getNextModul();
        let nextChildId = 0;

        if (nextModuleEl.length) {
            nextChildId = parseInt(nextModuleEl.attr('data-matrixchildid'), 10);
        }
        this.move({
            matrixId: this.getMatrixId(),
            pageId: 0,
            afterChildId: nextChildId
        });
    }
    onDuplicate() {
        this.duplicate({
            matrixId: this.getMatrixId(),
            pageId: 0,
            afterChildId: this.getChildId()
        });
    }
    initOverlay() {
        let addClass = '';
        let self = this;

        if (!this.needsCover()) {
            addClass += ' noCover';
        }

        //resize content if needed, before initializing the overlay
        this.sizeHoverContentOverlay();

        this.overlay = new ModuleOverlay(this.modul, {
            appendTo: '#module-overlay-group-' + this.moduleId
        });

        this.overlay.getOverlayElement().bind('click', function() {
            $(document).trigger('diy-editor-module-overlay-clicked', self);
        });

        this.overlay.getOverlayElement().addClass(addClass)
            .attr('data-moduleId', this.moduleId);

        //then start/define the hover observers after the overlay
        //the hover events are bound to them
        this.obsHover = $.proxy(this.showOverlay, this);
        this.obsHoverOut = $.proxy(this.hideOverlay, this);

        this.startHoverObserver();
        this.startHoverOutObserver();
    }
    isUpdating() {
        return this.modul.hasClass('hover_loading');
    }
    showOverlay(e?: JQueryEventObject) {
        let parentSection = this.getParentSection();
        let state = getStore().getState() as AppState;
        if (
            parentSection &&
            state.moduleSection &&
            parentSection.moduleId === state.moduleSection.moduleId &&
            state.moduleSection.manageGroupsActive
        ) {
            return;
        }

        if (this.overlayFrozen) {
            return;
        }

        /* if somehow we may trigger an opening of overlay over a module
        inside a Matrix Module */
        /*
        TODO this is an extreme measure taken against the possibility
        of a small bug becoming a big one. We try to make sure that the small
        elements are not hoverable and therefore not openable in case
        they are in a matrix that should be selected as a whole.
        Of course, this should be tackled at a higher level.
        However, in case this provokes bad results, adding
            window.matrixModuleAvoidEnforcingSelection = true;
        in the user scripts section will fix this
         */
        if (typeof matrixModuleAvoidEnforcingSelection !== 'undefined' &&
            matrixModuleAvoidEnforcingSelection) {
            if (!this.getMatrix().supportsDragging()) {
                let matrixModule = this.modul.parents('[data-moduletype="matrix"]');
                if (matrixModule.length) {
                    if (!mm[matrixModule.attr('data-moduleid')].overlayFrozen) {
                        return;
                    }
                }
            }
        }

        //if this is event generated
        if (e && this.getIsInEditMode() || this.isUpdating()) {
            return;
        }

        getStore().dispatch(moduleOverlayShow({moduleId: this.moduleId}));

    }
    repositionOverlay() {
        if (!this.hasActionBar) {
            this.overlay.position();
        }
    }
    /**
     * @desc given an event and a list of elements it will check
     * if the event was triggered on any of those elements or their children
     * @param {Event} e
     * @param {Array} list
     * @return {Boolean}
     * @private
     */
    _isEventTriggeredOnElementList(e: JQueryEventObject, list: JQuery) {
        if (!e) {
            return false;
        }

        let eventTarget = $(e.relatedTarget || (e as any).toElement).get(0);

        if (!eventTarget) {
            return false;
        }

        for (let i = 0; i < list.length; i++) {
            let listItem = list[i];

            if (eventTarget === listItem) {
                return true;
            }

            if ($.contains(listItem, eventTarget)) {
                return true;
            }
        }

        return false;
    }
    hideOverlay(e?: JQueryEventObject) {
        if (this.overlayFrozen) {
            return;
        }

        //if event triggered
        if (e && (this.isUpdating() || this.getIsInEditMode())) {
            return;
        }

        //the overlay is shown on mouse enter on the module element
        // when showing the overlay a leave event is generated on the module having as
        // event target the module overlay; this should be ignored
        let ignoreLeaveList = this.getOverlayWrapper();
        if (this._isEventTriggeredOnElementList(e, ignoreLeaveList)) {
            return;
        }

        let self = this;
        setTimeout(function() {
            self.overlay.hide();
        }, 0);
    }

    hideEditView() {
        if (!this.hasActionBar) {
            this.getEditorContainer().fadeOut(300);
            this.hideOverlay();
            if (this.getParentSection()) {
                getStore().dispatch(moduleActionBarClose(void 0));
            }
        } else {
            const parent = this.getParentSection();
            if (parent) {
                getStore().dispatch(moduleActionBarOpen({moduleId: parent.moduleId}));
            } else {
                getStore().dispatch(moduleActionBarClose(void 0));
            }
        }
    }

    /**
     * Opens the module in editing mode.
     *
     * @param Boolean hasConfigView - default true
     */
    showEditView(hasConfigView?: boolean) {
        this.overlay.show();

        this.getOverlayGroup().css('position', 'absolute');
        this.getOverlayGroup().find('.moduleEditorContainer').css('position', 'absolute');

        // default param values //
        if (typeof hasConfigView === 'undefined') {
            hasConfigView = true;
        }

        if (hasConfigView) {
            this.getEditorContainer().fadeIn(300);
        }

        this.setOpenStyle(hasConfigView);
    }

    getContentElement() {
        return document.getElementById('modul_' + this.moduleId);
    }

    openHelpArticle() {
        let helpArticleId = this.getEditorContainer().find('.moduleHelpLink').attr('data');
        help.openTopic(this.helpArticleId ? this.helpArticleId : helpArticleId);
    }

    freezeOverlay(state: boolean) {
        this.overlayFrozen = state === true ? state : false;
    }
    /**
     * Checks whether a target position (usually generated during a move operation)
     * is different than the current position of the element
     * The default assumption is that the position is different and it's negated if everything matches.
     * @param targetPosition
     * @returns {boolean}
     */
    isPositionChanged(targetPosition: {
        matrixId: number;
        pageId: number;
        afterChildId: number;
    }) {
        let positionIsDifferent = true;

        if (targetPosition.matrixId === this.getMatrixId()
            && (targetPosition.pageId === 0 || targetPosition.pageId === this.getPageId())
            // during a move request it's possible that the target position in the matrix to be after
            // the same matrix child id as this module or the matrix child of the previous module.
            // both cases indicate the same position
            && (targetPosition.afterChildId === this.getChildId() ||
                targetPosition.afterChildId === mm[this.moduleId].getAfterChildId())
        ) {
            positionIsDifferent = false;
        }

        return positionIsDifferent;
    }

    refresh(scrollToIt: boolean) {
        let self = this;
        this.showLoading();
        $.ajax({
            url: systemurl + 'app/module/module/get-data',
            data: {moduleId: this.moduleId},
            dataType: 'json',
            type: 'POST',
            success: function(response) {
                self.updateModul(response.data.cmsView, response.data.editView, response.data.resources);
                if (scrollToIt) {
                    mm[self.moduleId].getContentContainer().scrollIntoView();
                }
                self.hideLoading();
                $(document).trigger('diy-editor-module-refreshFinished');
            }
        });
    }
    onClickOutside() {
        this.onSaveBtnClick();
    }
    inPage() {
        let $content = this.getContentContainer();
        return $content.length > 0;
    }
    highlight() {
        let self = this;
        this.modul.addClass('highlight');
        setTimeout(function() {
            self.modul.removeClass('highlight');
        }, 3000);
    }

    getActionBarTabs(): TabOptions[] {
        let children: React.ReactNode;
        children = this.getEditViewComponent();
        if (!children) {
            children = React.createElement<ModuleActionBarContentProps>(
                ModuleActionBarContent,
                {
                    configView: this.getEditorContainer().closest('.diye')[0]
                }
            );
        }

        return [{label: this.textLabel, content: children}];
    }

    onActionBarTabChange(v: number) {
        // override this
    }

    getEditViewComponent(): React.ReactElement<any> {
        return null;
    }

    getFitsInContent() {
        return this.getData().fitsInContent;
    }

    addDoNotFitMask() {
        updateModuleFitsOverlays();
    }

    /* tslint:disable:member-ordering */
    static getActiveModule() {
        return activeModule;
    }

    static getInstance(moduleId: number|string) {
        return mm[moduleId];
    }

    static deleteInstance(moduleId: number|string) {
        delete mm[moduleId];
    }

    /**
     * exits the edit mode by saving the active module,
     * unless the user clicked on the delete icon, when we SHOULD NOT SAVE
     * but rather perform the desired action
     * @param deletedModuleId the module currently being deleted
     */
    static abortEditingModules(deletedModuleId?: number) {
        let activeModule = Modul.getActiveModule();

        if (activeModule && (!deletedModuleId || (deletedModuleId && activeModule.moduleId !== deletedModuleId))) {
            /* web component has a different save method */
            if (activeModule.getModuleType() === ModuleType.WEBCOMPONENT) {
                activeModule.runSaveAction();
            } else {
                activeModule.save();
            }
        }
    }

    /**
     * This method converts parameters usually found in the data-* attributes of the
     * module to parameters that can be used with Modul.insert
     *
     * @param {Object} data hash map with at least moduleName, moduleType and webcomponentId if applicable
     */
    static getInsertParams(data: ModuleInsertConfig) {
        let insertParams = {} as ModuleInsertParams;
        if (data.moduleType === 'local') {
            insertParams.moduleName = data.moduleName;

            /** @toDo section hack */
            if (data.moduleName.indexOf(ModuleType.SECTION) > -1) {
                let additionalData = {
                    'type': data.sectionName
                };
                insertParams.additionalParam = JSON.stringify(additionalData);
            }
        } else {
            insertParams.moduleName = data.moduleType === 'remote' ? 'remoteModule' : data.moduleType;

            let additionalData: { module: string; webcomponentId?: string; } = {
                'module': data.moduleName
            };

            if (data.moduleType === 'webcomponent') {
                additionalData.webcomponentId = data.webcomponentId;
            }

            insertParams.additionalParam = JSON.stringify(additionalData);
        }

        return insertParams;
    }

    static add(moduleParams: AddModuleParams, destinationParams: InsertDestinationParams) {
        return Modul.insert('add', {
            getInsertPlaceholder: function() { return $('<div class="diye-new-module-placeholder"></div>'); },
            getInsertParams: function() { return moduleParams; }
        }, destinationParams);
    }

    static handleLimitationsResponse (limitations: LimitationResponse) {
        let $sidebar = $("#cc-sa-sidebar");
        const critical = "modules-critical";
        const maximum = "modules-maximum";
        const closeControllers = function () {
            siteadminApi.close();
            siteadminApi.destroyController('cc-sa-item-pages');
            siteadminApi.destroyController('cc-sa-item-elements');
            siteadminApi.destroyController('cc-sa-item-appscatalog');
            siteadminApi.destroyController('cc-sa-item-sections');
        };

        if (limitations &&
                typeof limitations.hasReachedCriticalLimit !== 'undefined' &&
                typeof limitations.hasReachedMaximumLimit !== 'undefined'
        ) {
            switch (true) {
                case limitations.hasReachedCriticalLimit && !$sidebar.hasClass(critical):
                    closeControllers();
                    $sidebar.addClass(critical);
                break;
                case !limitations.hasReachedCriticalLimit && $sidebar.hasClass(critical):
                    closeControllers();
                    $sidebar.removeClass(critical);
                break;
                default: break;
            }

            switch (true) {
                case limitations.hasReachedMaximumLimit && !$sidebar.hasClass(maximum):
                    closeControllers();
                    $sidebar.addClass(maximum);
                break;
                case !limitations.hasReachedMaximumLimit && $sidebar.hasClass(maximum):
                    closeControllers();
                    $sidebar.removeClass(maximum);
                break;
                default: break;
            }
        }
        if (limitations && typeof limitations.renderWeight !== 'undefined') {
            renderWeight += limitations.renderWeight;
        }
    }

    static insert(
        action: string,
        moduleObj: InsertModuleObject|Modul,
        destinationParams: InsertDestinationParams
    ) {
        let pageId = destinationParams.pageId;
        let matrixId = destinationParams.matrixId;
        let afterChildId = destinationParams.afterChildId;

        let currentPageId = parseInt($("body").attr("data-pageid"), 10);

        if (!pageId) {
            destinationParams.pageId = pageId = currentPageId;
        }

        let fromMatrixId: number;
        if (action === 'move') {
            fromMatrixId = (moduleObj as Modul).getMatrixId();
        }

        /* tslint:disable:triple-equals */
        let loaderEl: JQuery;
        let placeholder: JQuery;
            // we need all that to insert in the same page
        let isSamePage = currentPageId == pageId;
        let isExactPosition =
                typeof matrixId !== 'undefined' &&
                typeof afterChildId !== 'undefined';
        /* tslint:enable:triple-equals */

        if (isSamePage && isExactPosition) {
            placeholder = moduleObj.getInsertPlaceholder();
            if (afterChildId) {
                let afterModuleEl = Matrix.getInstance(matrixId).getChildModuleEl(afterChildId);
                placeholder.insertAfter(afterModuleEl);
            } else {
                placeholder.prependTo(Matrix.getInstance(matrixId).matrix);
            }
            loaderEl = placeholder;
        } else {
            loaderEl = $('body');
        }

        let loaderCfg: loadingBoxParams = {
            useOverlay: true,
            zIndex: 1000000
        };
        if (!(isSamePage && isExactPosition)) {
            loaderCfg.loadingText = l10n.getString('module.addToPageWaitText');
        }

        loaderEl.loadingBox(loaderCfg).show();

        if (action === 'move') {
            (moduleObj as Modul).hide();
        }

        // make request
        let data = {} as any;
        let moduleData = moduleObj.getInsertParams();
        $.extend(data, moduleData, destinationParams);
        data.fromPageId = currentPageId;
        data.action = action;

        let errorHandler = function(message: string) {

            loaderEl.loadingBox().remove();

            msgEl.diy_messageDialog({
                zIndex: 100100 + 1 // bigger thant the siteadmin
            });
            msgEl.diy_messageDialog('showErrorMessage', message);

            // attach behavior for the help link inside the message
            msgEl.find('a.moduleHelpLink').click(function(e) {
                $.proxy(guidedAssistant._onModuleHelpLinkClick, guidedAssistant)(e);
            });

            if (placeholder) {
                placeholder.remove();
            }
            if (action === 'move') {
                (moduleObj as Modul).show();
            }
        };
        let successHandler = function(response: InsertSuccessResponse) {
            Modul.handleLimitationsResponse(response);
            if (!(isSamePage && isExactPosition)) {
                // we do a refresh if we have no exact position
                // even if we add on the same page
                // because the logic of automatic positioning is on server
                window.location.href = response.pageUrl;
                return;
            }

            loaderEl.loadingBox().remove();

            if (action === 'move' || action === 'duplicate') {
                /**
                 * @todo is this needed?
                 */
                if (action === 'move') {
                    (moduleObj as Modul).remove();
                }
            }
            placeholder.replaceWith(response.cmsView);
            $(response.editView).appendTo('body');

            // update counting of webcomponents
            let module = mm[response.moduleId];
            // if it's a matrix module, hide the busy mask - #DHDIY-20542
            if (module.getMatrixModuleParent()) {
                module.getMatrixModuleParent().hideBusyMask();
            }
            let moduleEl = module.getModuleElement();
            let webcomponentId = moduleEl.attr('data-webcomponentId');
            if (webcomponentId !== undefined) {
                let wpm = jimdoData.webcomponentsPerMatrix;
                if (fromMatrixId) {
                    wpm[fromMatrixId][webcomponentId] = parseInt(wpm[fromMatrixId][webcomponentId] as any, 10) - 1;
                }

                if (!wpm[matrixId]) {
                    wpm[matrixId] = {};
                }
                if (!wpm[matrixId][webcomponentId]) {
                    wpm[matrixId][webcomponentId] = 0;
                }
                wpm[matrixId][webcomponentId] = parseInt(wpm[matrixId][webcomponentId] as any, 10) + 1;
            }

            if (action === 'add' || action === 'duplicate') {
                // for callout listener
                if (Matrix.getInstance(matrixId).trigger instanceof Function) {
                    Matrix.getInstance(matrixId).trigger('onload', Matrix.getInstance(matrixId));
                }

                $(document).trigger('diy.editor.moduleSelector.moduleAdded',
                    [response.moduleId, response.childId, response.matrixID]);
            }

            if (action === 'add') {
                // mark module as new, so that we could delete it
                // if user press cancel, immediately after it is added
                if ((moduleData as AddModuleParams).moduleName !== ModuleType.SECTION) {
                    mm[response.moduleId].setIsNew(true);
                }
                mm[response.moduleId].open();
            } else if (action === 'move' || action === 'duplicate') {
                // scroll to just moved/duplicated module
                mm[response.moduleId].scrollToActiveView();
            }

            if (action === 'add') {
                // for callout listener
                let matrixInstance = Matrix.getInstance(matrixId);
                if (matrixInstance.trigger instanceof Function) {
                    matrixInstance.trigger('onload', matrixInstance);
                }

                $(document).trigger('diy.editor.moduleSelector.moduleAdded',
                    [response.moduleId, response.childId, response.matrixID]);

                if (Modul.getInstance(response.moduleId).getModuleType() === ModuleType.SECTION) {
                    $(document.body).trigger('NewSectionAdded.BSA');
                } else {
                    $(document.body).trigger('NewModuleAdded.BSA');
                }
            }

            /* trigger event that a module was added/moved/duplicated
            * used for sitecatalyst to track module opening */
            $(document).trigger('diy-editor-module-inserted-in-page', {
                'module': mm[response.moduleId],
                'action': action,
                'isSamePage': isSamePage
            });
        };

        $.ajax({
            url : systemurl + 'app/module/module/insert',
            data : data,
            dataType : 'json',
            type : 'POST',
            error : function(a) {
                errorHandler(l10n.getString('moduleErrorCurrent'));
            },
            success : function(response) {
                if (response.status === 'error') {
                    errorHandler(response.message);
                } else {
                    if (response.resources) {
                        Modul.handleResources(response.resources, () => {
                            successHandler(response);
                        });
                    } else {
                        successHandler(response);
                    }
                }

            }
        });
    }

    static handleResources(resources: Resources, callback?: (success: boolean) => void) {
        let executedCallback = false;

        if (resources.css && resources.css.length) {
            executedCallback = true;
            AppRegistry.getResourceManager().add(ResourceType.Css, resources.css, callback);
        }

        if (!executedCallback && callback) {
            callback(false);
        }
    }

    static getAllInstances(): Modul[] {
        return Object.keys(mm).map(Number).filter((n) => !Number.isNaN(n)).map((n) => Modul.getInstance(n));
    }
    /* tslint:enable:member-ordering */
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/Modul.ts
 **/